<template>
  <div>
    <div class="collect">
      <ul v-show="this.collectGoods.length">
        <li v-for="item in collectGoods">
          <div class="collectImg"><img class="goodsImg" :src="item.goods_img"></div>
          <p>{{item.goods_name}}</p>
          <p>{{item.shop_price.toLocaleString()}}円</p>
          <p><img src="../../assets/images/personal/detial_collect1.png">
            <button @click="delCollect(item)">お気に入りを削除</button>
          </p>
        </li>
      </ul>
      <div v-show="!this.collectGoods.length" class="order_no">
        <img src="../../assets/images/personal/wu.png" height="315" width="175"/>
        <span>お気に入り商品はありません。</span>
      </div>
    </div>
    <div class="Pcollect">
      <p class="PcollectTop">
        <span @click="back"><img src="../../assets/images/users/Return.png"></span>
        <span>お気に入り</span>
        <span></span>
        <!--<span>管理</span>-->
      </p>
      <ul v-show="this.collectGoods.length">
        <li v-for="item in collectGoods">
          <img class="CollectImg" :src="item.goods_img">
          <p>{{item.goods_name}}</p>
          <p>￥{{item.shop_price.toLocaleString()}}</p>
          <p><img src="../../assets/images/personal/detial_collect1.png">
            <button @click="delCollect(item)">お気に入りを削除</button>
          </p>
        </li>
      </ul>
      <div v-show="!this.collectGoods.length" class="order_Pno">
        <div class="no_goodsMain">
          <img src="../../assets/images/personal/wu.png" height="315" width="175"/>
          <span>あなたはまだ何の商品も用意していません。</span>
        </div>
      </div>
    </div>
    <p class="collectFooter"></p>
  </div>
</template>

<script>
  import {getCollectGoods, delCollectGoods} from './../../api/interface/users';
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        token: localStorage.getItem('token') || 0,
        collectGoods: []
      }
    },
    beforeMount(){
      if (this.token) {
        this.getCollectGoods()
      }
    },
    methods: {
      getCollectGoods(){
        getCollectGoods().then(result => {
          console.log(result);
          if (result.code === 1) {
            this.collectGoods = result.resData;
          }
        }).catch(err => {
          console.log(err);
        });
      },
      delCollect(item){
        console.log(item.goods_id);
        let goodsInfo = {
          goods_id: item.goods_id
        }
        delCollectGoods(goodsInfo).then(result => {
          console.log(result);
          if (result.code === 1) {
            this.collectGoods.forEach((t, index) => {
              if (t.goods_id == item.goods_id) {
                this.collectGoods.splice(index, 1)
              }
            })
          }
        }).catch(err => {
          console.log(err);
        })
      },
      back(){
        this.$router.go(-1)
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .collect {
      display: none;
    }
    .Pcollect {
      .PcollectTop {
        height: 50px;
        background-color: $TitColor;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        color: $whiteColor;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        span:nth-child(1),
        span:nth-child(3) {
          width: 50px;
          display: inline-block;
          height: 50px;
          img {
            margin-top: 10px;
            margin-left: 10px;
          }
        }
      }
      ul {
       position: absolute;
        top:55px;
        left: 0;
        right: 0;
        bottom:0;
        overflow-y: scroll;
        overflow-x: hidden;
        text-decoration: none;
        display: flex;
        flex-flow: row wrap;
        li {
          width: 4.8rem;
          margin: 0 0.1rem;
          margin-bottom: 5px;
          background-color: white;
          padding: 5px 0;
          border-radius: 5px;
          .CollectImg {
            width: 4rem;
            height: 4.5rem;
            margin-left: 0.4rem;
          }
          p {
            margin-top: 2px;
            text-align: center;
          }
          p:nth-child(2) {
            font-size: 16/$default-w+rem;
          }
          p:nth-child(3) {
            font-size: 14/$default-w+rem;
            color: $navcolor;
          }
          p:nth-child(4) {
            width: 80%;
            height: 25px;
            line-height: 25px;
            font-size: 14px;
            margin: 0 auto;
            margin-top: 5px;
            display: flex;
            justify-content: center;
            img {
              width: 20px;
              height: 20px;
              margin-top: 2.5px;
            }
            button {
              margin-top: 2.5px;
              height: 20px;
              border: none;
              outline: none;
              margin-left: 5px;
              background-color: white;
            }
          }

        }
      }
      .order_Pno {
        line-height: 150px;
        font-size: 12px;
        margin: 0 auto;
        .no_goodsMain {
          position: absolute;
          width: 100%;
          top: 50%;
          transform: translate(0, -50%);
          display: flex;
          justify-content: center;
          img {
            width: 100px;
            height: 150px;
          }
          a {
            color: $navcolor;
          }
        }
      }
    }
    .collectFooter {
      display: none;
    }
  }

  @media screen and(min-width: $P750screen) and(max-width: 889px) {
    .Pcollect {
      display: none;
    }
    .collect {
      width: 100%;
      background-color: #f6f7f9;
      height: $minheight;
      ul {
        text-decoration: none;
        display: flex;
        justify-content: flex-start;
        flex-flow: wrap;
        li {
          padding: 10px 0;
          width: 40%;
          margin: 0 5%;
          text-align: center;
          margin-top: 10px;
          background-color: white;;
          box-shadow: 5px 5px 5px #f0f0f0;
          .goodsImg {
            width: 220px;
            height: 250px;
            margin: 0 auto;
          }
          p {
            margin-top: 5px;
            text-align: center;
          }
          p:nth-child(2) {
            font-size: 20px;
          }
          p:nth-child(3) {
            font-size: 16px;
            color: $navcolor;
          }
          p:nth-child(4) {
            width: 70%;
            height: 25px;
            line-height: 25px;
            font-size: 14px;
            margin: 0 auto;
            margin-top: 5px;
            display: flex;
            justify-content: center;
            img {
              width: 20px;
              height: 20px;
            }
            button {
              height: 20px;
              border: none;
              outline: none;
              margin-left: 5px;
              background-color: white;

            }
          }
        }
      }
      .order_no {
        position: absolute;
        margin: 0 auto;
        margin-top: 100px;
        height: 315px;
        width: 100%;
        line-height: 326px;
        display: flex;
        font-size: 18px;
        letter-spacing: 2px;
        justify-content: center;
        a {
          color: $navcolor;
        }
      }
    }
    .collectFooter {
      height: 50px;
      width: 100%;
    }
  }

  @media screen and(min-width: 890px) {
    .Pcollect {
      display: none;
    }
    .collect {
      width: 100%;
      height: $minheight;
      background-color: #f9f9f9;
      ul {
        text-decoration: none;
        display: flex;
        flex-flow: wrap;
        li {
          padding: 10px 0.8%;
          float: left;
          width: 30%;
          min-width: 220px;
          margin: 10px 0.85%;
          background-color: white;
          box-shadow: 5px 5px 5px #f0f0f0;
          .collectImg {
            margin: 0 auto;
            width: 220px;
            height: 250px;
            img {
              width: 100%;
              height: 100%;
            }
          }

          p {
            margin-top: 5px;
            text-align: center;
          }
          p:nth-child(2) {
            font-size: 20px;
          }
          p:nth-child(3) {
            font-size: 16px;
            color: $navcolor;
          }
          p:nth-child(4) {
            width: 70%;
            height: 25px;
            line-height: 25px;
            font-size: 14px;
            margin: 0 auto;
            margin-top: 5px;
            display: flex;
            justify-content: center;
            img {
              width: 20px;
              height: 20px;
            }
            button {
              height: 20px;
              border: none;
              outline: none;
              margin-left: 5px;
              background-color: white;
            }
          }
        }
      }
      .order_no {
        position: absolute;
        margin: 0 auto;
        margin-top: 100px;
        height: 315px;
        width: 100%;
        line-height: 326px;
        display: flex;
        font-size: 18px;
        letter-spacing: 2px;
        justify-content: center;
        a {
          color: $navcolor;
        }
      }
    }
    .collectFooter {
      height: 50px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/collect.vue